export default __webpack_public_path__ + "static/media/press_2.230c1094.jpg";